export const fetchRegional = `query fetchRegional($kmatID: String!) {
    fetchRegional(kmatID: $kmatID)
  }`;
  